export function changeCssVariable(name, value) {
	const root = document.querySelector(':root');
    root.style.setProperty(name, value);
}

export function getCategoryLabel(type) {
	const typeLabels = {
        participant: 'Participantes',
        p: 'Participantes',
        organizer: 'Organizadores',
        o: 'Organizadores',
    }

    return typeLabels[type];
}

export function setUrlCategoryType(type) {
	const typeLabels = {
        participant: 'p',
        organizer: 'o',
    }

    return typeLabels[type];
}

export function getUrlCategoryType(type) {
	const typeLabels = {
        p: 'PARTICIPANT',
        o: 'ORGANIZER',
    }

    return typeLabels[type];
}
